export default function (state) {
    switch (state.type) {
        case 'edit':
            return 'Редактирование сертификата' + (state.form.Number ? ': ' : '') + state.form.Number;
        case 'add':
        default:
            return 'Добавление сертификата' + (state.form.Number ? ': ' : '') + state.form.Number;
    }
}